import * as React from 'react';

import Grid from '@mui/material/Grid';
import PlayCircleFilled from '@mui/icons-material/PlayCircleFilled';

import { AtomButton } from '@app/common/atoms';
import computer from '@app/imageAssets/homePage/computer.jpg';
import people1 from '@app/imageAssets/homePage/people-1.jpg';

import { NumberedListIcon, FeatureList } from './index';

class HowItWorks extends React.PureComponent {
  public renderButtonText(): JSX.Element {
    let icon: JSX.Element = <PlayCircleFilled />;

    return (
      <span className="home-page__see-how-skillz-work">
        <span className="home-page__see-how-skillz-work-icon">{icon}</span>
        <span className="home-page__see-how-skillz-work-text">See how Skillz works</span>
      </span>
    );
  }

  public renderHowItWorksList(): JSX.Element {
    return (
      <ul className="home-page__feature-list-list">
        <li className="home-page__feature-list-list-item">
          <NumberedListIcon color="purple" num={1} />
          <p>Setup and launch your Skillz powered game</p>
        </li>
        <li className="home-page__feature-list-list-item">
          <NumberedListIcon color="purple" num={2} />
          <p>Work with Skillz to grow your game and unlock real prizes</p>
        </li>
        <li className="home-page__feature-list-list-item">
          <NumberedListIcon color="purple" num={3} />
          <p>Follow our proven path to scale your business and become an Enterprise Partner</p>
        </li>
      </ul>
    );
  }

  public renderHowGetPaidList(): JSX.Element {
    return (
      <ul className="home-page__feature-list-list">
        <li className="home-page__feature-list-list-item">
          <NumberedListIcon color="green" num={1} />
          <p>Players pay entry fees to compete in your game</p>
        </li>
        <li className="home-page__feature-list-list-item">
          <NumberedListIcon color="green" num={2} />
          <p>Winners take home their prizes</p>
        </li>
        <li className="home-page__feature-list-list-item">
          <NumberedListIcon color="green" num={3} />
          <p>You and Skillz split the rest</p>
        </li>
      </ul>
    );
  }

  public handleClick = (): void => {
    window.open('https://youtu.be/ssIg7HinZwY', '_blank');
  };

  public render(): JSX.Element {
    return (
      <Grid
        container={true}
        spacing={3}
        justifyContent={'center'}
        className={'home-page__how-works-paid-container'}
      >
        <AtomButton
          id="home-page__see-how-skillz-work-button"
          onClick={this.handleClick}
          buttonContent={this.renderButtonText()}
          buttonType="secondary"
        />

        <FeatureList
          title="How it works"
          image={computer}
          altDescription="Developers integrate their games into Skillz system with their computer"
          list={this.renderHowItWorksList()}
        />
        <FeatureList
          title="How you get paid"
          image={people1}
          altDescription="Game developers work collaboratively with Skillz's engineers on their computer"
          list={this.renderHowGetPaidList()}
          reverse={true}
        />
      </Grid>
    );
  }
}

export { HowItWorks };
